import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';

interface NumberInputFieldProps extends FormlyFieldProps {
  min: number;
  max: number;
  minFractionDigits: number;
  maxFractionDigits: number;
  currencyName: string;
  mode: 'decimal' | 'currency' | string;
}

@Component({
  selector: 'app-number-input-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    InputNumberModule,
    NgIf,
  ],
  templateUrl: './number-input-field.component.html',
  styleUrl: './number-input-field.component.scss',
})
export class NumberInputFieldComponent extends FieldType<
  FieldTypeConfig<NumberInputFieldProps>
> {
  override defaultOptions = {
    props: {
      min: undefined,
      max: undefined,
      minFractionDigits: undefined,
      maxFractionDigits: undefined,
      currencyName: 'USD',
      mode: 'decimal',
    },
  };
}
